import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";
// Import version z package.json (funguje v create-react-app)
import packageJson from '../../package.json';

export default function AppFooter() {
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        display: "flex",
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: theme.palette.mode === "light" ? "#f0f8ff" : "#121212",
        color: theme.palette.mode === "light" ? "f0f8ff" : "white",
      })}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: { xs: "flex-start", lg: "center" },
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Typography
          variant="body1"
          align="left"
          sx={{
            whiteSpace: { xs: "normal", lg: "nowrap" },
            overflowWrap: "anywhere",
          }}
        >
          © {new Date().getFullYear()} {" "}
          <Link href="https://www.spvs.cz/">
            Šumperská provozní a vodohospodářská společnost, a.s.
          </Link>
          {" | Systém vytvořil "}
          <Link href="https://www.ortex.cz/"> ORTEX spol. s r.o.</Link>
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", whiteSpace: { xs: "normal", lg: "nowrap" } }}
        >
          Verze aplikace: {packageJson.version}
        </Typography>
      </Container>
    </Box>
  );
}
